export const ColorUtils = {
    getCorrectTextColor: function (hex) {

        let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

        let hRed = this.hexToR(hex);
        let hGreen = this.hexToG(hex);
        let hBlue = this.hexToB(hex);

        let cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;
        if (cBrightness > threshold) {
            return "#000000";
        } else {
            return "#ffffff";
        }
    },

    hexToR: function (h) {
        return parseInt((this.cutHex(h)).substring(0, 2), 16);
    },

    hexToG: function (h) {
        return parseInt((this.cutHex(h)).substring(2, 4), 16);
    },

    hexToB: function (h) {
        return parseInt((this.cutHex(h)).substring(4, 6), 16)
    },

    cutHex: function (h) {
        return (h.charAt(0) === "#") ? h.substring(1, 7) : h
    },
    rgb2hex: function (rgb) {
        let hexDigits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
        let hex = function (x) {
            return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
        }
        rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
}


/*//test colortable
var colPairs = new Array("00","22","44","66","99","aa","cc","ff");
for(i=0;i<colPairs.length;i++){
    for(j=0;j<colPairs.length;j++){
        for(k=0;k<colPairs.length;k++){
            //build a hexcode
            theColor = "#"+colPairs[i]+colPairs[j]+colPairs[k];

            //checkf for correct textcolor in passed hexcode
            textcolor = getCorrectTextColor(theColor);

            //output div
            document.write("<div style='background-color:" + theColor + ";color:"+textcolor+";' class='colorblock'>" + theColor + "</div>");
        }
        document.write("<br/>");
    }
}*/


